/* eslint-disable @typescript-eslint/no-explicit-any */

// eslint-disable-next-line @typescript-eslint/no-unnecessary-type-constraint
const mergePrefilled = <T extends unknown>(oldPayload: T, newPayload?: T | null): T => {
	if (newPayload !== null && newPayload !== undefined) {
		// @ts-expect-error - TS2698 - Spread types may only be created from object types. | TS2698 - Spread types may only be created from object types.
		return { ...oldPayload, ...newPayload };
	}
	return oldPayload;
};

const returnActualValue = (value: (string | number)[] | string | number): string => {
	if (Array.isArray(value)) {
		return value[0].toString();
	}
	return value.toString();
};

// @ts-expect-error - TS7023 - 'mergeFormat' implicitly has return type 'any' because it does not have a return type annotation and is referenced directly or indirectly in one of its return expressions. | TS7006 - Parameter 'format' implicitly has an 'any' type.
const mergeFormat = (format, finalKey: string, finalValue: string | Array<string>) => {
	// Ideally format can be object or string
	// Format will only contain 1 object having single key/value where value can be null or an object
	// go inside and wherever we find first null, replace the same with the value.

	// some of the mutation use fieldId whereas other uses like priorityId
	// so whichever key has value === ID will replace the same with the proper mutationKey
	if (typeof format === 'string') {
		if (format === 'ID') {
			return finalKey;
		}
		return format;
	}

	// recursively goes inside to find the null and key param and replace with the corresponding values
	// Also checks for array like labels

	// @ts-expect-error - TS7024 Typescript 5.9.2 upgrade
	return Object.keys(format).reduce<Record<string, any>>((accumulator, currentKey) => {
		const currentValue = format[currentKey];
		if (Array.isArray(currentValue)) {
			const mappedValue = Array.isArray(finalValue) ? finalValue : [finalValue];
			return {
				// eslint-disable-next-line jira/js/no-reduce-accumulator-spread
				...accumulator,
				// @ts-expect-error - TS7024 Typescript 5.9.2 upgrade
				[currentKey]: mappedValue.map((val) => mergeFormat(currentValue[0], finalKey, val)),
			};
		}
		return {
			// eslint-disable-next-line jira/js/no-reduce-accumulator-spread
			...accumulator,
			[currentKey]:
				currentValue === null
					? returnActualValue(finalValue)
					: mergeFormat(format[currentKey], finalKey, finalValue),
		};
	}, {});
};

export { mergePrefilled, returnActualValue, mergeFormat };
